import utils from './utils';

const URL = `${BASE_API_URL}/offers`;
const STUDENT_URL = `${URL}/student`;
const TEACHER_URL = `${URL}/teacher`;

export default {
    getTeacherSalary: () => utils.get(`${TEACHER_URL}/salary/`),
    getLanguageList: () => utils.get(`${URL}/languages/`),
    getCourseProductList: () => utils.get(`${URL}/course_products/`),
    getTeacherList: (language) => utils.get(`${URL}/teachers/`, language),
    getOffererList: () => utils.get(`${URL}/offerers/`),
    getOfferList: (page) => utils.get(`${URL}/`, page),
    getStudentOffer: (uuid) => utils.get(`${STUDENT_URL}/${uuid}/`),
    getExtraLessonsProductList: (language) => utils.get(`${URL}/extra_lessons/`, language ? {language} : undefined),
    getExtraLessonsProductPrice: (productId, lessons) => {
        const url = `${URL}/extra_lessons/${productId}/price/`;
        console.log('[API offers.js] getExtraLessonsProductPrice called', {
            productId,
            lessons,
            url,
            queryParams: lessons,
            fullUrl: `${url}?${Object.keys(lessons).map(k => `${k}=${lessons[k]}`).join('&')}`
        });
        const result = utils.get(url, lessons);
        console.log('[API offers.js] getExtraLessonsProductPrice returning promise', result);
        return result;
    },
    createOffer: (data) => utils.post(`${URL}/create`, data),
    updateOffer: (uuid, data) => utils.put(`${URL}/${uuid}/update`, data),
    deleteOffer: (uuid) => utils.delete(`${URL}/${uuid}/update`),
    createOfferStudent: (data) => utils.post(`${STUDENT_URL}/create`, data),
    updateOfferStudent: (uuid, data) => utils.put(`${STUDENT_URL}/${uuid}/update`, data),
    deleteOfferStudent: (uuid) => utils.delete(`${STUDENT_URL}/${uuid}/update`),
}



// WEBPACK FOOTER //
// ./src/api/offers.js